import React from 'react';

const ThumbsUp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#clip0_6817_33388)">
      <path
        d="M3.5 14.5C3.85227 14.5119 4.20165 14.5679 4.54 14.6667C7.20667 15.4267 7.35333 15.5133 8.06 15.5133H11.3333C12.3284 15.5183 13.2896 15.1522 14.0292 14.4866C14.7689 13.8209 15.2338 12.9034 15.3333 11.9133L15.5333 8.51333C15.5694 7.81948 15.3629 7.13471 14.9493 6.57641C14.5358 6.01811 13.9409 5.62107 13.2667 5.45333C12.5467 5.27333 11.54 5.27333 11.54 4.26667V2C11.54 1.60218 11.382 1.22064 11.1007 0.93934C10.8194 0.658035 10.4378 0.5 10.04 0.5C9.64218 0.5 9.26064 0.658035 8.97934 0.93934C8.69804 1.22064 8.54 1.60218 8.54 2C8.54 2.06667 8.98 8.03333 3.54 8.03333L3.5 14.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 6.5H0.5V15.5H3.5V6.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6817_33388">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ThumbsUp;
